'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _dropDownMenu = require('common/components/drop-down-menu');

var _dropDownMenu2 = _interopRequireDefault(_dropDownMenu);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TopBarMenuLink = _react2['default'].createClass({
    displayName: 'TopBarMenuLink',


    propTypes: {
        'linkText': _react2['default'].PropTypes.string.isRequired,
        'linkUrl': _react2['default'].PropTypes.string,
        'linkOptions': _react2['default'].PropTypes.object,
        'linkOverrideColors': _react2['default'].PropTypes.object,
        'pageToHighLight': _react2['default'].PropTypes.string,
        'useWhite': _react2['default'].PropTypes.bool
    },

    componentDidMount: function componentDidMount() {
        if (this.state.menuLeft == null) {
            // Only set once
            this.getMenuLeft();
        }
    },


    // dropdown menu-related functions
    getInitialState: function getInitialState() {
        return {
            'menuOpen': false,
            'menuLeft': null
        };
    },
    getMenuLeft: function getMenuLeft() {
        var node = _reactDom2['default'].findDOMNode(this);
        var parent = node.offsetParent;
        if (node && parent) {
            var rect = node.getBoundingClientRect();
            var parentRect = parent.getBoundingClientRect();
            this.setState({
                menuLeft: rect.left - parentRect.left
            });
        }
    },
    openMenu: function openMenu() {
        this.setState({ menuOpen: true });
    },
    setStateMousedOverDropDownMenuTrue: function setStateMousedOverDropDownMenuTrue() {
        this.setState({ mousedOverDropDownMenu: true });
    },
    setStateMousedOverDropDownMenuFalse: function setStateMousedOverDropDownMenuFalse() {
        this.setState({ mousedOverDropDownMenu: false });
    },
    closeMenu: function closeMenu() {
        this.setState({ menuOpen: false });
        var self = this;
        window.setTimeout(function () {
            if (self.state.mousedOverDropDownMenu !== true) {
                self.setState({ menuOpen: false });
            }
        }, 200);
    },
    render: function render() {

        var cx = _classnames2['default'];
        var rowClasses = {
            'm-link-list--link--container': true,
            'm-link-list--link-break-1': false
        };
        var linkClasses = {
            'm-link-list--link': true
        };
        var linkDefaultColors = {
            'c-white': this.props.useWhite ? true : false,
            'hc-warm-chinchilla': this.props.useWhite ? true : false,
            'hc-cerulean': this.props.useWhite ? false : true,
            'c-ashen': this.props.useWhite ? false : true
        };

        var linkColors = this.props.linkOverrideColors ? this.props.linkOverrideColors : linkDefaultColors;

        if (this.props.linkOptions && this.props.linkOptions.hasOwnProperty('class')) {
            var newProperty = {};
            var newPropertyKey = this.props.linkOptions['class'];
            newProperty[newPropertyKey] = true;
            linkClasses = _hfReactHelper2['default'].extend(newProperty, linkClasses);
        }

        if (this.props.linkUrl == this.props.pageToHighLight) {
            linkClasses = _hfReactHelper2['default'].extend({
                'm-link-list--currentPage': true
            }, linkClasses);
        }

        if (this.props.linkOptions && this.props.linkOptions.hasOwnProperty('colors')) {
            var propertyColorOverride = {};
            var propertyColorOverrideKey = this.props.linkOptions.colors;
            propertyColorOverride[propertyColorOverrideKey] = true;
            linkClasses = _hfReactHelper2['default'].extend(propertyColorOverride, linkClasses);
        } else {
            linkClasses = _hfReactHelper2['default'].extend(linkColors, linkClasses);
        }

        if (this.props.linkOptions && this.props.linkOptions.hasOwnProperty('container_class')) {
            var containerClasses = this.props.linkOptions.container_class.split(' ');
            for (var i = 0; i < containerClasses.length; i++) {
                var clazz = containerClasses[i];
                rowClasses[clazz] = true;
            }
        }

        // Stringify classes
        linkClasses = cx(linkClasses);
        rowClasses = cx(rowClasses);

        var dropDownMenu;
        if (this.props.linkOptions.hasOwnProperty('sub_menu_items') && this.state.menuOpen) {

            var style;
            if (this.props.linkOptions.hasOwnProperty('sub_menu_lock_to_parent') && this.props.linkOptions.sub_menu_lock_to_parent) {
                style = {};
                style.left = this.state.menuLeft ? this.state.menuLeft + 15 : 0;
                style.transform = 'translateX(-30%)';
            } else {
                style = { right: 40 }; // Default, right side menu
            }

            dropDownMenu = _react2['default'].createElement(
                'div',
                {
                    onMouseEnter: this.setStateMousedOverDropDownMenuTrue, onMouseLeave: this.setStateMousedOverDropDownMenuFalse },
                _react2['default'].createElement(_dropDownMenu2['default'], {
                    id: this.props.linkOptions.sub_menu_id,
                    ref: 'dropDownMenu',
                    style: style,
                    dropDownMenuLinkData: this.props.linkOptions.sub_menu_items,
                    className: this.props.linkOptions.sub_menu_class })
            );
        }

        var dropDownArrow;
        if (this.props.linkOptions.hasOwnProperty('show_menu_drop_down_arrow') && this.props.linkOptions.show_menu_drop_down_arrow) {
            dropDownArrow = _react2['default'].createElement(
                'span',
                { className: 'm-drop-down-menu--drop-down-arrow' },
                '\u25BE'
            );
        }

        return _react2['default'].createElement(
            'div',
            { className: rowClasses, onMouseEnter: this.openMenu, onMouseLeave: this.closeMenu },
            _react2['default'].createElement(
                'a',
                { className: linkClasses, href: this.props.linkUrl, target: this.props.linkOptions.target, tabIndex: '-1' },
                this.props.linkText,
                dropDownArrow
            ),
            dropDownMenu
        );
    }
});

module.exports = TopBarMenuLink;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/top-bar-menu/top-bar-menu-link.jsx
 ** module id = 1029
 ** module chunks = 0
 **/